import { render, staticRenderFns } from "./Natures.vue?vue&type=template&id=087258c3&scoped=true"
import script from "./Natures.vue?vue&type=script&lang=js"
export * from "./Natures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087258c3",
  null
  
)

export default component.exports